export default () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="8" cy="8" r="7.5" fill="#fff" stroke="#ED544D" />
		<path
			d="M8.746 11.704a.785.785 0 0 1-.794.776.785.785 0 0 1-.794-.776c0-.43.355-.777.794-.777.438 0 .794.348.794.777zM9.043 4.46a1.146 1.146 0 0 0-.24-.598 1.088 1.088 0 0 0-.851-.433c-.33 0-.631.162-.834.41a1.148 1.148 0 0 0-.257.622c-.006.06-.005.127 0 .186l.451 5.058a.618.618 0 0 0 .185.388.648.648 0 0 0 .873.033.62.62 0 0 0 .22-.42l.453-5.059c.004-.06.005-.125 0-.186z"
			fill="#ED544D"
		/>
	</svg>
);
